import RoundButton from '@oberoninternal/travelbase-ds/components/action/RoundButton';
import TextButton from '@oberoninternal/travelbase-ds/components/action/TextButton';
import ArrowLeft from '@oberoninternal/travelbase-ds/components/figure/ArrowLeft';
import ArrowRight from '@oberoninternal/travelbase-ds/components/figure/ArrowRight';
import useIntervalClick from '@oberoninternal/travelbase-ds/hooks/useIntervalClick';
import { FlexProps } from '@rebass/grid';
import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { PlannerControlsWrapper, PlannerViewActionsContext, PlannerViewContext } from './Planner';

interface Props extends FlexProps {
    loading?: boolean;
}
const PlannerControls: FC<React.PropsWithChildren<Props>> = ({ children, loading, ...props }) => {
    const plannerViewActions = useContext(PlannerViewActionsContext);
    const plannerViewState = useContext(PlannerViewContext);

    if (!plannerViewActions || !plannerViewState) {
        throw new Error('PlannerControls can only be used within a Planner component');
    }

    const { scrollBy, scrollToToday, getMonthDimensions } = plannerViewActions;
    const { canGoBackwards, canGoForwards } = plannerViewState;

    const useScrollByMonthWidth = (positive = true) =>
        useIntervalClick(() => {
            const monthWidth = getMonthDimensions();
            scrollBy(positive ? monthWidth : -monthWidth, !loading);
        }, 500);
    const incrementScrollProps = useScrollByMonthWidth();
    const decrementScrollProps = useScrollByMonthWidth(false);

    return (
        <PlannerControlsWrapper {...props}>
            {children}
            <Controls>
                {/* For now you can only go to today if the current month is loaded */}
                <TextButton onClick={() => scrollToToday(!loading)} disabled={!canGoBackwards}>
                    <FormattedMessage defaultMessage="Vandaag" />
                </TextButton>
                <StyledRoundButton variant="outline" size="large" disabled={!canGoBackwards} {...decrementScrollProps}>
                    <ArrowLeft />
                </StyledRoundButton>
                <StyledRoundButton variant="outline" size="large" disabled={!canGoForwards} {...incrementScrollProps}>
                    <ArrowRight />
                </StyledRoundButton>
            </Controls>
        </PlannerControlsWrapper>
    );
};

export default PlannerControls;

const Controls = styled.div`
    display: none;
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        display: flex;
    }
    align-items: center;
    margin-left: auto;
    > button + button {
        margin-left: ${({ theme }) => theme.spacing['30_Small']};
    }
`;

const StyledRoundButton = styled(RoundButton)`
    opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
`;
